import {
  Cake,
  CalendarDays,
  PartyPopper,
  Megaphone,
  Users,
  Monitor,
  MessageSquare,
  Database,
  Cloud,
  FileSpreadsheet,
} from "lucide-react";

import { employees } from "../data/employees";
import { holidays } from "../data/holidays";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  getUpcomingBirthdays,
  getUpcomingAnniversaries,
  getNextHoliday,
} from "../utils/dashboardUtils";

function Home() {
  const birthdays = getUpcomingBirthdays(employees);
  const anniversaries = getUpcomingAnniversaries(employees);
  const nextHoliday = getNextHoliday(holidays);
  const navigate = useNavigate();
  const quickAccess = [
    {
      name: "Microsoft Teams",
      icon: <Monitor size={20} />,
    },
    {
      name: "Mattermost",
      icon: <MessageSquare size={20} />,
    },
    {
      name: "Inventree",
      icon: <Database size={20} />,
    },
    {
      name: "Cloud Storage",
      icon: <Cloud size={20} />,
    },
    {
      name: "Inventory Sheet",
      icon: <FileSpreadsheet size={20} />,
    },
  ];

  return (
    <div className="space-y-6 md:space-y-8">

      {/* HERO SECTION */}
      <div  className="
    relative
    overflow-hidden
    rounded-[24px]
    md:rounded-[32px]
    p-6
    md:p-10
    text-white
  "
        style={{
          background:
            "linear-gradient(135deg,#C00000 0%,#8B0000 50%,#111111 100%)",
        }}
      >
        <div className="absolute top-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-20 w-60 h-60 bg-red-500/20 rounded-full blur-3xl"></div>

        <div className="relative z-10">
          <h1 className="text-3xl md:text-5xl font-bold">
            Welcome Back 👋
          </h1>

          <p className="mt-3 text-sm md:text-lg text-white/80">
            Stay connected, informed, and productive with Lightspeed Photonics.
          </p>
        </div>
      </div>

      {/* KPI CARDS */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">

        {/* HOLIDAY */}
        <div
          className="
          bg-white
          rounded-3xl
          p-5 md:p-7
          border
          border-red-100
          shadow-[0_8px_30px_rgb(0,0,0,0.06)]
          hover:-translate-y-1
          hover:shadow-[0_15px_40px_rgb(0,0,0,0.10)]
          transition-all
          "
        >
          <div className="flex items-center gap-3 mb-5">
            <CalendarDays className="text-[#C00000]" />
            <h2 className="font-semibold">
              Next Holiday
            </h2>
          </div>

          {nextHoliday && (
            <>
              <h1 className="text-4xl md:text-5xl font-bold text-[#C00000]">
                {new Date(nextHoliday.date).getDate()}
              </h1>

              <p className="text-gray-500">
                {new Date(nextHoliday.date).toLocaleDateString(
                  "en-IN",
                  {
                    month: "short",
                    year: "numeric",
                  }
                )}
              </p>

              <h3 className="text-xl font-semibold mt-4">
                {nextHoliday.name}
              </h3>
            </>
          )}
        </div>

        {/* UPCOMING EVENT */}
        <div
          className="
          bg-white
          rounded-3xl
          p-5 md:p-7
          border
          border-red-100
          shadow-[0_8px_30px_rgb(0,0,0,0.06)]
          hover:-translate-y-1
          hover:shadow-[0_15px_40px_rgb(0,0,0,0.10)]
          transition-all
          "
        >
          <div className="flex items-center gap-3 mb-5">
            <Users className="text-[#C00000]" />
            <h2 className="font-semibold">
              Upcoming Event
            </h2>
          </div>

          <h1 className="text-4xl md:text-5xl font-bold text-[#C00000]">
            29
          </h1>

          <p className="text-gray-500">
            Jun 2026
          </p>

          <h3 className="text-xl font-semibold mt-4">
            Investor Visit
          </h3>

          <p className="text-sm text-gray-500 mt-2">
            Demos need to be showcased.
          </p>
        </div>

        {/* ANNOUNCEMENT */}
        <div
          onClick={() => navigate("/dashboard/announcements")}
          className="
          bg-white
          rounded-3xl
          p-5 md:p-7
          border
          border-red-100
          shadow-[0_8px_30px_rgb(0,0,0,0.06)]
          hover:-translate-y-1
          hover:shadow-[0_15px_40px_rgb(0,0,0,0.10)]
          transition-all
          cursor-pointer
          "
        >
          <div className="flex items-center gap-3 mb-5">
            <Megaphone className="text-[#C00000]" />
            <h2 className="font-semibold">
              Latest Announcement
            </h2>
          </div>

          <h3 className="font-semibold text-lg text-gray-800">
            TP LINK WiFi Network Update
          </h3>

          <p className="text-gray-500 mt-2">
            New tp-link router has been installed and configured successfully.
          </p>
        </div>
      </div>
      {/* BIRTHDAYS + ANNIVERSARIES */}
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">

        {/* BIRTHDAYS */}
        <div className="bg-white rounded-3xl p-7 shadow-sm border border-gray-100">

          <div className="
            flex
            flex-col
            sm:flex-row
            sm:items-center
            justify-between
            gap-4
            p-4
            mb-5
            rounded-2xl
            bg-gradient-to-r
            from-red-50
            to-white
            border
            border-red-100
            hover:shadow-md
            transition-all
          ">
            <Cake className="text-[#C00000]" />
            <h2 className="text-lg md:text-xl font-semibold">
              Upcoming Birthdays
            </h2>
          </div>

          <div className="space-y-4">

            {birthdays.map((employee) => (
              <div
                key={employee.id}
                className="
                flex
                items-center
                justify-between
                p-4
                rounded-2xl
                bg-gradient-to-r
                from-red-50
                to-white
                border
                border-red-100
                hover:shadow-md
                transition-all
                "
              >
                <div className="flex items-center gap-4">

                  <div
                    className="
                    w-12
                    h-12
                    rounded-full
                    bg-[#C00000]
                    text-white
                    flex
                    items-center
                    justify-center
                    font-semibold
                    "
                  >
                    {employee.name.charAt(0)}
                  </div>

                  <div>
                    <p className="font-semibold">
                      {employee.name}
                    </p>

                    <p className="text-xs text-gray-500">
                      {employee.id}
                    </p>
                  </div>

                </div>

                <div className="text-right">
                  <p className="text-[#C00000] text-lg">
                    🎂
                  </p>

                  <p className="font-medium">
                    {employee.nextBirthday.toLocaleDateString(
                      "en-IN",
                      {
                        day: "numeric",
                        month: "short",
                      }
                    )}
                  </p>
                </div>
              </div>
            ))}

          </div>
        </div>

        {/* ANNIVERSARIES */}
        <div className="bg-white rounded-3xl p-7 shadow-sm border border-gray-100">

          <div className="flex
              flex-col
              sm:flex-row
              sm:items-center
              justify-between
              gap-4
              p-4
              mb-5
              rounded-2xl
              bg-gradient-to-r
              from-red-50
              to-white
              border
              border-red-100
              hover:shadow-md
              transition-all">
            <PartyPopper className="text-[#C00000]" />
            <h2 className="text-lg md:text-xl font-semibold">
              Upcoming Work Anniversaries
            </h2>
          </div>

          <div className="space-y-4">

            {anniversaries.map((employee) => (
              <div
                key={employee.id}
                className="
                flex
                items-center
                justify-between
                p-4
                rounded-2xl
                bg-gradient-to-r
                from-red-50
                to-white
                border
                border-red-100
                hover:shadow-md
                transition-all
                "
              >
                <div className="flex items-center gap-4">

                  <div
                    className="
                    w-12
                    h-12
                    rounded-full
                    bg-black
                    text-white
                    flex
                    items-center
                    justify-center
                    font-semibold
                    "
                  >
                    {employee.name.charAt(0)}
                  </div>

                  <div>
                    <p className="font-semibold">
                      {employee.name}
                    </p>

                    <p className="text-xs text-gray-500">
                      {employee.id}
                    </p>
                  </div>

                </div>

                <div className="text-right">
                  <p className="text-[#C00000] text-lg">
                    🎉
                  </p>

                  <p className="font-medium">
                    {employee.nextAnniversary.toLocaleDateString(
                      "en-IN",
                      {
                        day: "numeric",
                        month: "short",
                      }
                    )}
                  </p>
                </div>
              </div>
            ))}

          </div>

        </div>

      </div>

    </div>
  );
}

export default Home;